<template>
  <div class="row">
    <div class="col-12">
      <template>
        <component
          :is="component"
          :documentInfo.sync="documentInfo"
        />
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'fire-detection-alarm-system-doc',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          title: '',
        }
      },
    },
  },
  data() {
    return {
      editable: true,
      documentInfo: {
        documentClassCd: 'EPPV', // FIRE_DETECTION_ATTACH
        title: '방폭 전기/계장기계•기구 선정기준',
      },
      component: null,
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      this.component = () => import('@/pages/psi/documentMaster.vue');
      this.getList();
    },
    getList() {
    },
    reset() {
      Object.assign(this.$data.documentInfo, this.$options.data().documentInfo);
    },
  }
};
</script>